import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { authToken } from 'config/axios';
import { catchAsync } from 'helpers';

export const logout = createAsyncThunk(
  'auth/logout',
  catchAsync(async () => {
    await axios.post('/auth/logout');
    authToken.set();
  })
);
